import { createContext, useContext } from 'react'

const SettingsModalEmbedContext = createContext(false)

export const SettingsModalEmbedProvider = SettingsModalEmbedContext.Provider

/** True when user groups (or other admin surfaces) render inside the settings modal overlay. */
export const useSettingsModalEmbed = () => useContext(SettingsModalEmbedContext)
